import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ScoreCategories from "routes/routes/Administrator/routes/MYPAcademicSetup/routes/ScoreCategories";
export default store => ({
  path: ":termId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ScoreCategories(store)],
});
